import { createStore } from "owa-satcheljs";
import type { AccountAndCoprincipalSourceId, AccountSourceList } from "./schema/AccountSourceList";

const defaultStore: AccountSourceList = {
    globalSettingsSourceId: "",
    sourcesBySourceId: new Map<string, AccountAndCoprincipalSourceId>(),
    nextAccountSessionAtom: 0,
    sources: [],
    removedAccounts: [],
    licensingIdentities: [],
};

/**
 * STRATIFY DEBT: A MobX/Satchel store does not belong in a utility package. This package is
 * temporarily classified as utility to unblock migration even though account additions, removals,
 * boot-state transitions, and policy updates are observable. UI consumers rerender from this
 * state, and data-worker synchronization uses an autorun over it.
 *
 * Remove cross-layer store dependencies by passing account context to service and GraphQL
 * consumers, and replace these reactive contracts before removing MobX. Once those dependencies
 * are corrected, classify this package as store or move the state behind an appropriate
 * lower-layer abstraction.
 *
 * Tracking bug:
 * https://outlookweb.visualstudio.com/Outlook%20Web/_workitems/edit/455885
 */
const defaultExport: () => AccountSourceList = createStore<AccountSourceList>("AccountSourceList", defaultStore);
export default defaultExport;
